<template>
	<div class="flex gap-3">
		<div class="flex flex-col gap-1 pl-8">
			<div :class="navOptionVariants({ variant: props.variant })">
				<div
					class="absolute inset-y-0 -left-8 mx-0 my-auto flex size-5 items-center justify-center"
				>
					<slot name="icon" />
				</div>
				<slot name="title" />
			</div>
			<div
				v-if="variant === 'description'"
				class="text-xs font-normal leading-[18px] text-muted-foreground"
			>
				<slot name="description" />
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { NavOptionVariantProps } from '.';

import { navOptionVariants } from '.';

const props = defineProps<{
	variant?: NavOptionVariantProps['variant'];
}>();
</script>
